<ul class="c__total-time">
  <li>
    <span class="is-overline c__label">
      {{ "recipes.timer.total" | translate}}
    </span>
    <span class="c__duration {{isDevice$ ? 'brand--h3' : 'brand--h2'}}">
      {{ timeOverview.totalTime }}
    </span>
  </li>

  @if (isDevice$ && recipeUser) {
    <li class="c__recipe-by">
      <sd-recipe-user [isSmall]="true" [user]="recipeUser" />
    </li>
  }
</ul>

@if (isDevice$) {
  <span class="c__separator"></span>
}

<ul class="c__steps-time">
  @if (timeOverview.preparation) {
    <li>
      <div class="c__label">
        @if (timeOverview.preparation.icon) {
          <sd-icon [size]="iconSize.medium" [name]="timeOverview.preparation.icon" />
        }
        <span class="is-overline" id="timePreparationTime">
          {{ "recipes.timer.preparation" | translate }}
        </span>
      </div>
      <span class="brand--h4 c__duration" aria-labelledby="timePreparationTime" role="definition">
        {{ timeOverview.preparation.text }}
      </span>
    </li>
  }
  @if (timeOverview.cooking) {
    <li>
      <div class="c__label">
        @if (timeOverview.cooking.icon) {
          <sd-icon [size]="iconSize.medium" [name]="timeOverview.cooking.icon" />
        }
        <span class="is-overline" id="timerCookingTime">
          {{ "recipes.timer.cooking" | translate }}
        </span>
      </div>
      <span class="brand--h4 c__duration" aria-labelledby="timerCookingTime" role="definition">
        {{ timeOverview.cooking.text }}
      </span>
    </li>
  }
  @if (timeOverview.cooling) {
    <li>
      <div class="c__label">
        @if (timeOverview.cooling.icon) {
          <sd-icon [size]="iconSize.medium" [name]="timeOverview.cooling.icon" />
        }
        <span class="is-overline" id="timerCoolingTime">
          {{ "recipes.timer.cooling" | translate }}
        </span>
      </div>
      <span class="brand--h4 c__duration" aria-labelledby="timerCoolingTime" role="definition">
        {{ timeOverview.cooling.text }}
      </span>
    </li>
  }
</ul>
